import { render } from "./5PenempatanTenagaKerja.vue?vue&type=template&id=2a68fdec"
import script from "./5PenempatanTenagaKerja.vue?vue&type=script&lang=js"
export * from "./5PenempatanTenagaKerja.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__